export default "<p>\r\n  category works!\r\n</p>\r\n"